// extracted by mini-css-extract-plugin
export var container = "Landing-module--container--9fQ-s";
export var subheading = "Landing-module--subheading--PX6SE";
export var heading = "Landing-module--heading--WG16x";
export var red = "Landing-module--red--KSlWT";